var _path, _path2, _line, _line2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmile = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 11v1a10 10 0 1 1-9-10"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14s1.5 2 4 2 4-2 4-2"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 9,
  x2: 9.01,
  y1: 9,
  y2: 9
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 15,
  x2: 15.01,
  y1: 9,
  y2: 9
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 5h6"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M19 2v6"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmile);
export default ForwardRef;